import { useEffect } from 'react';
import { logger } from '@/lib/logger';

/**
 * useServiceWorker — Registers the service worker for offline support
 * Only registers in production builds
 */
export function useServiceWorker() {
  useEffect(() => {
    if ('serviceWorker' in navigator && import.meta.env.PROD) {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          logger.log('ServiceWorker', 'Registered:', registration.scope);

          // Check for updates every hour
          setInterval(() => {
            registration.update();
          }, 60 * 60 * 1000);

          // Listen for new updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  logger.log('ServiceWorker', 'New version available — refresh to update');
                }
              });
            }
          });
        })
        .catch((error) => {
          logger.error('ServiceWorker', 'Registration failed:', error);
        });
    }
  }, []);
}

export default useServiceWorker;
